/**
 * Excel Export Utility
 * 
 * Uses dynamic import to load xlsx library only when needed.
 * This saves ~500KB from the initial bundle.
 */

/**
 * Export data to Excel file
 * @param {Array<Object>} data - Array of objects to export
 * @param {string} sheetName - Name of the Excel sheet
 * @param {string} fileName - Name of the output file (without .xlsx extension)
 */
export const exportToExcel = async (data, sheetName = "Sheet1", fileName = "export") => {
  // Dynamically import xlsx only when needed
  const XLSX = await import("xlsx");
  
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};
